import React, { useState, useEffect, useCallback } from 'react';
import { Routes, Route } from 'react-router-dom';
import { authAPI } from '../services/api';
import AdminLoginPage from './AdminLoginPage';
import AdminLayout from '../components/AdminLayout';
import AdminDashboard from './AdminDashboard';
import AdminBlogs from './AdminBlogs';
import AdminConferences from './AdminConferences';
import AdminCommunity from './AdminCommunity';
import AdminMessages from './AdminMessages';
import AdminTestimonials from './AdminTestimonials';
import AdminFAQs from './AdminFAQs';
import AdminMedia from './AdminMedia';
import AdminGallery from './AdminGallery';
import AdminNewsletter from './AdminNewsletter';
import AdminAwards from './AdminAwards';

const AdminPage = () => {
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const data = await authAPI.me();
      setUser(data);
    } catch { setUser(null); }
    finally { setChecking(false); }
  }, []);

  useEffect(() => { checkAuth(); }, [checkAuth]);

  if (checking) {
    return <div className="min-h-screen bg-slate-950 flex items-center justify-center"><div className="text-slate-400">Loading...</div></div>;
  }

  if (!user) {
    return <AdminLoginPage onLogin={setUser} />;
  }

  return (
    <AdminLayout user={user} onLogout={() => setUser(null)}>
      <Routes>
        <Route index element={<AdminDashboard />} />
        <Route path="blogs" element={<AdminBlogs />} />
        <Route path="conferences" element={<AdminConferences />} />
        <Route path="community" element={<AdminCommunity />} />
        <Route path="faqs" element={<AdminFAQs />} />
        <Route path="media" element={<AdminMedia />} />
        <Route path="gallery" element={<AdminGallery />} />
        <Route path="awards" element={<AdminAwards />} />
        <Route path="messages" element={<AdminMessages />} />
        <Route path="testimonials" element={<AdminTestimonials />} />
        <Route path="newsletter" element={<AdminNewsletter />} />
      </Routes>
    </AdminLayout>
  );
};

export default AdminPage;
